<template>
  <div class="ai-prompts-container">
    <h1>AI Prompts - Coming Soon</h1>
  </div>
</template>

<script>
export default {
  name: 'AIPrompts'
}
</script>

<style scoped>
.ai-prompts-container {
  padding: 20px;
}
</style>